import { render, staticRenderFns } from "./ChairtyName.vue?vue&type=template&id=a9d99590"
import script from "./ChairtyName.vue?vue&type=script&lang=js"
export * from "./ChairtyName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports